module.exports = __webpack_public_path__ + "img/SAV_2019Fall_NumberNine_Interior_CC_040_JJ_v2.3d2881ba.jpg";